import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

import { signUpModel } from '../../models/signup/signup.model';


@Component({
	selector: 'app-request-manage',
	templateUrl: './myProfile.component.html'
})
export class myProfileComponent implements OnInit {

	//variable deceleration
	public errorMsg: string = "";
	public errorMsgPopup: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public allUserData: any = [];
	public registeredUserData: any = null;
	public editable: boolean = false;
	public signUpModel: signUpModel = new signUpModel;
	public CreateUserResponseData: any = "";
	public openupmobile: boolean = false;
	public openupKyc: boolean = false;
	public KYCdata: any = {};
	public isHideMobileMsg: boolean = false;



	constructor(public http: HttpTestService, public session: sessionServices,
		public route: Router,
		public actvRoute: ActivatedRoute) { }

	ngOnInit() {
		this.getSession();

	}


	//get session details
	getSession = function () {

		this.sessionData = this.session.getSessionDetails();
		this.getConsumerDetails();
	}


	//get consumer details
	getConsumerDetails = function () {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.sessionData.consumerId;

		self.http.getUserDetailsByConsNo(requestedConsumer)
			.subscribe(
				(data) => {
					self.allUserData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.allUserData = "";
				},
				() => {
					if (self.allUserData.name) {
						self.registeredUserData = self.allUserData;
						self.signUpModel.consumerMobile = self.allUserData.mobile;
						self.signUpModel.consumerEmail = self.allUserData.emailid;
					} else {
						self.registeredUserData = "";
					}

				}
			);
	}

	cancelReg = function () {
		//document.getElementById("id1").style.display = "none";
		//document.getElementById("id2").style.display = "none";
		var self = this;
		self.errorMsgPopup = "";
		self.signUpModel.consumerMobile = "";
		self.signUpModel.consumerEmail = self.registeredUserData.emailid;
		self.editable = false;
		self.openupmobile = false;
		self.openupKyc = false;
		self.signUpModel.consumerAADHAAR = "";
		self.signUpModel.consumerPAN = "";
	}

	editOn = function () {
		var self = this;
		self.editable = true;
	}


	createUser = function () {
		var self = this;
		self.errorMsg = "";
		self.errorMsgPopup = "";
		self.successMsg = "";

		self.registeredUserData.emailid = self.signUpModel.consumerEmail;
		self.registeredUserData.password = self.sessionData.credChange;

		self.http.createUser(self.registeredUserData)
			.subscribe(
				(data) => {
					self.CreateUserResponseData = data;
				},
				(error) => {
					self.errorMsgPopup = "Some Error Occured";
				},
				() => {

					self.cancelReg();
					self.successMsg = "Consumer Id " + self.CreateUserResponseData.consumerNo + " successfully updated.";
					self.openupmobile = false;
					self.editable = false;

				}
			);


	}


	openupmobilepopup = function () {
		var self = this;
		// document.getElementById("id1").style.display = "block";
		self.openupmobile = true;
	}

	openupkycpopup = function () {
		var self = this;
		// document.getElementById("id2").style.display = "block";
		self.openupKyc = true;
		self.signUpModel.consumerAADHAAR = "";
		self.signUpModel.consumerPAN = "";

		self.http.getKYC(self.registeredUserData.consumerNo)
		.subscribe((data) => 
		{
			self.KYCdata = data;
		},
		(error) => {
			self.errorMsg = error;
		},
		() => {

			if (self.KYCdata != "") {
				self.signUpModel.consumerAADHAAR = self.KYCdata.adharNo;
				self.signUpModel.consumerPAN = self.KYCdata.panNo;
			}
		});
	}

	addTolist = function () {
		var self = this;
		//self.errorMsgPopup = "";
		var mobileObject = {
			"type": "",
			"consumerId": self.registeredUserData.consumerNo,
			"mobNo": self.signUpModel.consumerMobile,
			"createDate": new Date().getTime(),
			"lastModifiedDate": null
		};


		self.registeredUserData.phonelist.push(mobileObject);
		self.signUpModel.consumerMobile = "";
		if (self.signUpModel.consumerMobile == null) {
			this.isHideMobileMsg = false;
		} else {
			self.signUpModel.consumerMobile = "";
			this.isHideMobileMsg = true;
		}
	}

	setPrimary = function (index) {
		var self = this;
		for (var i = 0; i < self.registeredUserData.phonelist.length; i++) {
			self.registeredUserData.phonelist[i].type = "";
		}
		self.registeredUserData.phonelist[index].type = "P";
	}


	postKYC = function () {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		var postData = {
			"consumerId": self.registeredUserData.consumerNo,
			"adharNo": self.signUpModel.consumerAADHAAR,
			"panNo": self.signUpModel.consumerPAN,
			"createDate": null,
			"lastModifiedDate": null
		};
		self.http.postKYC(postData)
			.subscribe(
				(data) => {
					self.CreateUserResponseData = data;
				},
				(error) => {
					self.errorMsg = error;
				},
				() => {

					self.cancelReg();
					self.successMsg = "Consumer Id " + self.CreateUserResponseData.consumerNo + " successfully updated.";
					self.openupmobile = false;
					self.editable = false;
					self.openupKyc = false;

				}
			);
	}


}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/profile/myProfile.component.ts